export const VERTICALS = {
  0: 'Women',
  1: 'Men',
  2: 'Kids',
  3: 'Home'
};

export type Vertical = keyof typeof VERTICALS;
